module.exports = "/_next/static/fonts/NewSpiritCondensed-Light-a87df4adcfe4323a310e0a0af87ce870.woff2";